import { reactive } from 'vue'
import { supabase } from '@/supabase.js';


export const _store = reactive({
  appuser: {},

//   async signin(email, password) {
//     const { user, error } = await supabase.auth.signInWithPassword({
//       email,
//       password,
//     });
//     this.appuser = user;


//     if (error) {
//       this.error = error.message;
//       return null;
//     }
//     // mrouter.push({path:'/'});

//   //   this.error = null;
//   //   return user;
//   },

  async logout() {
    const { error } = await supabase.auth.signOut();
    if (error) {
      this.error = error.message;
    } else {
      this.appuser = {};
      this.error = null;
    }
  },

  async fetchUser() {
    const { data: { user } } = await supabase.auth.getUser();
    this.appuser = user;
  },
})